import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const STOP = new Set(["les", "des", "pour", "une", "dans", "avec", "sur", "par", "vos", "votre", "quel", "quelle", "quels", "comment", "sans", "the", "and", "guide", "casaneo", "que", "qui", "est", "aux", "plus", "tout", "tous", "faut", "savoir", "avant", "entre", "chez", "cas", "2026", "2025"]);
const words = (s) => new Set((s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").split(/[^a-z0-9]+/).filter((w) => w.length > 3 && !STOP.has(w)));

/** 3 guides les plus proches (mots communs titre + slug + description), sinon les plus récents. */
export function pickRelated(current, items, n = 3) {
  const base = words(`${current.title} ${current.slug.replace(/-/g, " ")} ${current.description || ""} ${current.keyword || ""}`);
  return (items || [])
    .filter((o) => o.slug !== current.slug)
    .map((o) => ({ o, score: [...words(`${o.title} ${o.slug.replace(/-/g, " ")} ${o.description || ""}`)].filter((w) => base.has(w)).length }))
    .sort((a, b) => b.score - a.score || (b.o.updated_at || "").localeCompare(a.o.updated_at || ""))
    .slice(0, n)
    .map((x) => x.o);
}

export function RelatedGuides({ current, items }) {
  const related = pickRelated(current, items);
  if (!related.length) return null;
  return (
    <section className="mt-14" data-testid="seo-guide-related">
      <div className="flex items-end justify-between gap-4">
        <h2 className="font-serif text-2xl text-white">À lire ensuite</h2>
        <Link to="/blog" className="text-xs text-brass hover:underline inline-flex items-center gap-1" data-testid="seo-guide-related-all">Tous les guides <ArrowRight className="h-3 w-3" /></Link>
      </div>
      <div className="mt-5 grid gap-4 sm:grid-cols-3">
        {related.map((o) => (
          <Link key={o.slug} to={`/guide/${o.slug}`} className="group rounded-2xl border border-white/10 bg-white/[0.04] overflow-hidden hover:bg-white/[0.08] transition-colors" data-testid={`seo-guide-related-${o.slug}`}>
            <div className="aspect-[1200/630] w-full overflow-hidden bg-[#0b2a5a]">
              <img src={o.cover || `${process.env.REACT_APP_BACKEND_URL}/api/public/og/guide/${o.slug}.png`} alt={o.cover_alt || o.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
            </div>
            <div className="p-4">
              <h3 className="font-serif text-base text-white leading-snug line-clamp-3">{o.title}</h3>
              <span className="mt-2 inline-flex items-center gap-1 text-xs text-brass group-hover:gap-2 transition-all">Lire <ArrowRight className="h-3 w-3" /></span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
